import { Component, ViewChild, AfterViewInit, inject } from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule, SortDirection } from '@angular/material/sort';
import { merge, Observable, of as observableOf } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { CommentService } from '../../../services/comment.service';
import { Comment } from '../../../model/Comments';
import { DeviceDetectorService } from '../../../services/device-detector.service';
import { DialogService } from '../../../services/dialog.service';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-admin-librerias',
  imports: [CommonModule, MatTableModule, MatProgressSpinnerModule, MatSortModule, MatPaginatorModule, MatSelectModule, ReactiveFormsModule, MatIconModule],
  templateUrl: './librerias.component.html',
  styleUrl: './librerias.component.scss'
})
export class LibreriasAdminComponent {

  displayedColumns: string[] = [];
  data: Comment[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  filtrosForm: FormGroup;

  @ViewChild(MatPaginator) paginator: MatPaginator = new MatPaginator();
  @ViewChild(MatSort) sort: MatSort = new MatSort();

  constructor(private service: CommentService, private deviceService: DeviceDetectorService, private dialogService: DialogService, fb: FormBuilder) {
    this.filtrosForm = fb.group({
      estado: ['no-leido'],
      reason: ['all']
    });
  }

  ngOnInit() {
    if (this.deviceService.isMobile()) {
      this.displayedColumns = [];
    }
  }

  ngAfterViewInit() {

    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.service!.getComments(this.getParams())
            .pipe(catchError(() => observableOf(null)));
        }),
        map(data => {
          this.isLoadingResults = false;
          this.isRateLimitReached = data === null;

          if (data === null) {
            return [];
          }

          this.resultsLength = data.total_count;
          return data.items;
        }),
      )
      .subscribe(data => (this.data = data));
  }

  buscar() {
    this.service!.getComments(this.getParams())
      .subscribe((data) => {
        this.data = data.items;
        this.resultsLength = data.total_count;
      });
  }

  getParams(): { estado: string, reason: string, page: number } {
    let obj: any = {
      estado: this.filtrosForm.value.estado,
      reason: this.filtrosForm.value.reason === 'all' ? undefined : this.filtrosForm.value.reason,
      page: this.paginator.pageIndex + 1
    };
    Object.keys(obj).forEach(key => obj[key] === undefined ? delete obj[key] : {});
    return obj;
  }


}
